export default __webpack_public_path__ + "static/media/avatar-2.bc9b4b87.svg";